module.exports = __webpack_public_path__ + "static/lframe-travel-loan-7866c36297e6beeb8c14e9cd14b33578.png";